<template>
  <Card class="basicInfo">
    <div class="basicInfo-header">
      <div class="basicInfo-user">
        <img v-if="info.avatar" style="width: 40px; height: 40px" :src="info.avatar" alt />
        <img
          v-else-if="info.gender === 0"
          style="width: 40px; height: 40px"
          src="../../../images/woman.png"
          alt
        />
        <img v-else style="width: 40px; height: 40px" src="../../../images/man.png" alt />
        <span style="font-weight: 500; padding-left: 20px">{{info.name}}</span>
        <span
          v-if="info.age"
          style="
            margin-left: 10px;
            color: #fff;
            background: #ebb053;
            padding: 1px 2px;
            border-radius: 4px;
            font-size: 12px;
            line-height: 16px;
          "
        >{{ info.age ? info.age + "岁" : "--" }}</span>
        <span
          v-if="info.weight"
          style="
          margin-left: 10px;
          color: #fff;
          background: #00b287;
          padding: 1px 2px;
          border-radius: 4px;
          font-size: 12px;
          line-height: 16px;
        "
        >{{info.weight}}kg</span>
        <span style="padding-left: 10px; font-weight: 500">{{info.id_card}}</span>
      </div>
      <div class="basicInfo-operate">
        <el-button round @click="deleteInfo">删除</el-button>
        <el-button round @click="editInfo">编辑</el-button>
        <el-button
          v-if="info.user_id && info.apply && info.apply.status == 1 && patientInfo && patientInfo.team_conversation_id"
          round
          @click="sendMsg()"
        >发送消息</el-button>
        <el-button
          v-if="!info.apply || info.apply.status == 2 || info.apply.status == 3 || info.apply.status == 4"
          round
          @click="showInviteModal"
        >邀请签约</el-button>
        <el-button
          v-if="info.user_id && info.apply && info.apply.status == 1"
          round
          @click="showAssignModal"
        >分配管理方案</el-button>
      </div>
    </div>
    <div v-if="!show" class="basicInfo-content">
      <caring-title
        style="padding-left: 20px"
        text="基本信息"
        color="#333"
        :customIconStyle="{
          width: '12px',
          height: '12px',
          borderRadius: '4px',
        }"
      />
      <basic-list :dataSource="list" :info="info">
        <template #address>
          <span>{{ info.province }} {{ info.city }} {{ info.county }} {{ info.address }}</span>
        </template>
        <template #groups>
          <span
            class="tag"
            v-for="g in info.groups || []"
            :style="{ backgroundColor: g.color, borderColor: g.color }"
            :key="g.id"
          >{{ g.name }}</span>
          <span
            class="tag"
            :style="{ backgroundColor: '#fff', fontSize: '13px', border: '1px dashed #4286f1', color: '#4286f1',padding: '2px 6px',cursor: 'pointer' }"
            @click="showGroupModal"
          >
            <i class="el-icon-plus"></i>
            添加
          </span>
        </template>
        <template #tags>
          <el-tag
            v-for="g in info.tags || []"
            :closable="true"
            :key="g.id"
            :color="g.color"
            size="small"
            effect="dark"
            type="info"
            :style="{ borderColor: g.color }"
            @close="closeTag(g)"
          >{{g.name}}</el-tag>
          <span
            class="tag"
            :style="{ backgroundColor: '#fff', fontSize: '13px', border: '1px dashed #4286f1', color: '#4286f1',padding: '2px 6px',cursor: 'pointer' }"
            @click="showTagModal"
          >
            <i class="el-icon-plus"></i>
            添加
          </span>
        </template>
        <template #invisible_groups>
          <span
            class="tag"
            v-for="g in info.invisible_groups || []"
            :style="{ backgroundColor: g.color }"
            :key="g.id"
          >{{ g.name }}</span>
        </template>
        <template #medical_card_type>
          <span>
            {{
            info.medical_card_type === 'citizen_card'
            ? '市民卡' : info.medical_card_type === 'medical_card'
            ? '医保卡' : info.medical_card_type === 'id_card'
            ? '身份证' : info.medical_card_type}}
          </span>
        </template>
        <template #in_hos_time>
          <span>{{info.in_hos_time ? info.in_hos_time.slice(0,10) : ''}}</span>
        </template>
      </basic-list>
      <div v-if="info.apply " style="background: #fffbf4;padding:30px;border-radius: 12px">
        <div style="color: #FF9E00;padding-bottom: 12px;display: flex;align-items:center">
          <Icon type="md-information-circle" />
          <span style="padding-left: 6px">签约信息</span>
        </div>
        <div v-if="info.apply.status === 1" style="display: flex;color: #738299">
          <div>
            <div v-if="info.apply.reason">签约备注: {{info.apply.reason}}</div>
            <div v-if="info.imgs" style="display:flex;align-items:center ">
              病历图片:
              <el-image
                v-for="(img, i) in info.imgs"
                :key="i"
                :src="img"
                :preview-src-list="info.imgs"
                style="width: 50px; height: 50px"
              />
            </div>
            <div>签约状态: 已加入</div>
          </div>
        </div>
        <div v-else style="display: flex;color: #738299;align-items: center">
          <div style="flex: 1;">
            <div v-if="info.apply.reason">签约备注: {{info.apply.reason}}</div>
            <div v-if="info.imgs" style="display:flex;align-items:center ">
              病历图片:
              <el-image
                v-for="(img, i) in info.imgs"
                :key="i"
                :src="img"
                :preview-src-list="info.imgs"
                style="width: 50px; height: 50px"
              />
            </div>
            <div>签约状态: {{info.apply.status == -1 ? '已邀请' : inviteStatus[info.apply.status]}}</div>
          </div>
          <div v-if="info.apply.status == 0">
            <el-button round type="warning" plain @click="showRefuseModal">拒绝签约</el-button>
            <el-button round type="warning" :loading="loading" @click="agreeApply">同意签约</el-button>
          </div>
        </div>
      </div>
      <!-- <caring-title
        style="padding-left: 20px"
        text="签约信息"
        color="#333"
        :customIconStyle="{
          width: '12px',
          height: '12px',
          borderRadius: '4px',
        }"
      />
      <Row :gutter="16">
        <Col span="24" class-name="marginBottom6">
          <div>申请说明:</div>
        </Col>
        <Col span="24" class-name="marginBottom6">
          <div>病历图片:</div>
        </Col>
      </Row>-->
    </div>
    <div class="panelSwitch" @click="handleSwitch">
      <Icon type="ios-arrow-down" v-if="show" />
      <Icon type="ios-arrow-up" v-else />
    </div>
    <Modal
      v-model="groupModal"
      title="添加分组"
      :mask-closable="false"
      width="500"
      @on-cancel="cancelGroupModal"
    >
      <div>
        <Select v-model="cur" multiple>
          <Option
            v-for="t in groups"
            :key="t.id"
            :value="t.id"
            :disabled="!!(info.groups && info.groups.find(ta => ta.id === t.id))"
          >{{t.name}}</Option>
        </Select>
      </div>
      <div slot="footer" style="text-align: center">
        <el-button type="info" round @click="cancelGroupModal">取消</el-button>
        <el-button type="primary" round :loading="groupModalLoading" @click="saveGroup">保存</el-button>
      </div>
    </Modal>
    <Modal
      v-model="tagModal"
      title="添加标签"
      :mask-closable="false"
      width="500"
      @on-cancel="cancelTagModal"
    >
      <div>
        <Select v-model="cur" multiple>
          <Option
            v-for="t in tags"
            :key="t.id"
            :value="t.id"
            :disabled="!!(info.tags && info.tags.find(ta => ta.id === t.id))"
          >{{t.name}}</Option>
        </Select>
      </div>
      <div slot="footer" style="text-align: center">
        <el-button type="info" round @click="cancelTagModal">取消</el-button>
        <el-button type="primary" round :loading="tagModalLoading" @click="saveTag">保存</el-button>
      </div>
    </Modal>
    <edit-modal
      :info="info"
      :loading="dialogLoading"
      :show="dialogVisible"
      @close="handleClose"
      @submit="handleSubmitInfo"
    />
  </Card>
</template>
<script>
import CaringTitle from '../../../components/caring-title.vue'
import BasicList from '../components/basicList.vue'
import EditModal from '../components/medicalInfoModal.vue'
import { handleApplyPatientApi } from '../../../api/user'
import { addConfirmedPerson, deleteConfirmedPerson } from '../../../api/person'
import { getTag, TransferTag, removeTagPage } from '../../../api/tag'
import { getGroup, TransferGroup, getPatientInfo } from '../../../api/group'
import { Message, MessageBox } from 'element-ui'
import route from '../../../route/config'
export default {
  components: {
    CaringTitle,
    BasicList,
    EditModal,
  },
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      inviteStatus: ['待审批', '已加入', '已拒绝', '已退出', '已解约'],
      loading: false,
      show: false,
      list: [
        {
          col: 6,
          label: '患者ID:',
          value: 'user_id',
        },
        {
          col: 6,
          label: '联系方式:',
          value: 'phone',
        },
        {
          col: 6,
          label: '出生日期:',
          value: 'birthday',
        },
        {
          label: '地址:',
          col: 6,
          value: 'address',
          slot: 'address',
        },
        {
          label: '亲属联系方式:',
          col: 6,
          value: 'relatives_phone',
        },
        {
          col: 6,
          label: '亲属联系方式2:',
          value: 'relatives_phone2',
        },
        {
          label: '住院号:',
          col: 6,
          value: 'in_hospital_no',
        },
        {
          col: 6,
          label: '放疗号:',
          value: 'radiotherapy_no',
        },
        {
          col: 6,
          label: '就诊卡号:',
          value: 'medical_card',
        },
        {
          col: 6,
          label: '就诊卡类型:',
          value: 'medical_card_type',
          slot: 'medical_card_type',
        },
        {
          col: 6,
          label: '责任医生:',
          value: 'charge_doctor_name',
        },
        {
          col: 6,
          label: '入院时间:',
          value: 'in_hos_time',
          slot: 'in_hos_time',
        },
        {
          label: '备注:',
          col: 6,
          value: 'remark',
        },
        {
          col: 6,
          label: '诊断:',
          value: 'diagnosis',
        },
        {
          col: 12,
          label: '其他诊断:',
          value: 'other_diagnosis',
        },

        {
          label: '分组:',
          value: 'groups',
          col: 12,
          slot: 'groups',
        },
        {
          label: '标签:',
          value: 'tags',
          col: 12,
          slot: 'tags',
        },
        {
          label: '评估分析:',
          value: 'invisible_groups',
          col: 24,
          slot: 'invisible_groups',
        },
      ],
      tagModal: false,
      groupModal: false,
      groupModalLoading: false,
      tagModalLoading: false,
      tags: [],
      groups: [],
      cur: [],
      patientInfo: null,
      dialogVisible: false,
      dialogLoading: false,
    }
  },
  created() {
    this.getTagList()
    this.getGroupList()
    this.getPatientInfo()
  },
  methods: {
    deleteInfo() {
      console.log(this.info)
      MessageBox.confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        deleteConfirmedPerson(this.info.id)
          .then((res) => {
            if (res.code === 0) {
              this.$Message.success('删除成功!')

              if (
                this.$store.state.allSelectedKeys.find(
                  (s) => s.key === 'confirmedLists'
                )
              ) {
                this.refesh()
              }
              this.$store.commit('setAllSelectedKeys', {
                type: 'delete',
                name: 'medicalBasic',
                title: this.info.name + '—慢病信息',
                key: `medicalBasic?${this.info.id}`,
                extra: {
                  user: this.info,
                },
              })

              this.$store.commit('setAllSelectedKeys', {
                type: 'add',
                name: 'confirmedLists',
                title: route['confirmedLists'].title,
                key: `confirmedLists`,
                extra: {},
              })
            } else {
              this.$Message.warning(res.message)
            }
          })
          .catch(() => {})
      })
    },
    refesh() {
      const list = this.$store.state.allSelectedKeys.map((l) => {
        if (l.key === 'confirmedLists') {
          l.refesh = true
        }
        return l
      })
      this.$store.commit('setAllSelectedKeys', {
        type: 'allAdd',
        list,
      })
      setTimeout(() => {
        const list = this.$store.state.allSelectedKeys.map((l) => {
          if (l.key === 'confirmedLists') {
            l.refesh = false
          }
          return l
        })
        this.$store.commit('setAllSelectedKeys', {
          type: 'allAdd',
          list,
        })
      }, 400)
    },
    editInfo() {
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    handleSubmitInfo(params) {
      this.dialogLoading = true
      addConfirmedPerson(params)
        .then((res) => {
          this.dialogLoading = false
          if (res.code === 0) {
            this.$Message.success('编辑保存成功!')
            this.handleClose()
            this.$emit('save')
          } else {
            this.$Message.warning(res.message)
          }
        })
        .catch(() => {
          this.dialogLoading = false
        })
    },
    sendMsg() {
      this.$store.commit('setSessionModal', true)
      this.$store.commit(
        'setAssignConversationId',
        'team-' + this.patientInfo.team_conversation_id
      )
    },
    getPatientInfo() {
      getPatientInfo({
        patient_id: this.info.patient_id,
      }).then((res) => {
        if (res.code === 0) {
          this.patientInfo = res.data
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    getTagList() {
      getTag({ type: 1, page: 1, size: 999, need_page: 0 }).then((res) => {
        if (res.code === 0) {
          this.tags = res.data
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    getGroupList() {
      getGroup({
        type: 1,
        page: 1,
        size: 999,
        need_page: 0,
        invisible: 0,
      }).then((res) => {
        if (res.code === 0) {
          this.groups = res.data
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    closeTag(g) {
      console.log(g)
      removeTagPage({
        type: '1',
        patient_ids: [this.info.patient_id],
        tag_ids: [g.id],
      }).then((res) => {
        if (res.code === 0) {
          this.$Message.success('删除成功')
          this.$emit('save')
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    saveTag() {
      this.tagModalLoading = true
      TransferTag({
        type: 1,
        patient_ids: [this.info.patient_id],
        to_tag_ids: this.cur,
      })
        .then((res) => {
          this.tagModalLoading = false
          if (res.code === 0) {
            this.tagModal = false
            this.$emit('save')
          } else {
            this.$Message.error(res.message)
          }
        })
        .catch(() => {
          this.tagModalLoading = false
        })
    },
    saveGroup() {
      this.groupModalLoading = true
      TransferGroup({
        type: 1,
        patient_ids: [this.info.patient_id],
        group_ids: this.cur,
      })
        .then((res) => {
          this.groupModalLoading = false
          if (res.code === 0) {
            this.groupModal = false
            this.$emit('save')
          } else {
            this.$Message.error(res.message)
          }
        })
        .catch(() => {
          this.groupModalLoading = false
        })
    },
    showTagModal() {
      this.tagModal = true
      this.cur = []
    },
    cancelTagModal() {
      this.tagModal = false
      this.tagModalLoading = false
    },
    showGroupModal() {
      this.groupModal = true
      this.cur = []
    },
    cancelGroupModal() {
      this.groupModal = false
      this.groupModalLoading = false
    },
    handleSwitch() {
      this.show = !this.show
    },
    showAssignModal() {
      this.$emit('show-assign')
    },
    showInviteModal() {
      this.$emit('show-invite')
    },
    showRefuseModal() {
      this.$emit('show-refuse')
    },
    agreeApply() {
      this.loading = true
      handleApplyPatientApi({
        apply_id: this.info.apply.id,
        code: 1,
      })
        .then((res) => {
          this.loading = false
          if (res.code === 0) {
            this.$emit('save')
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="less">
.basicInfo {
  position: relative;
  background: #fff;
  &-header,
  &-user,
  &-operate {
    display: flex;
    align-items: center;
  }
  &-header {
    justify-content: space-between;
  }
  &-content {
    padding-top: 12px;
    .list {
      display: flex;
      flex-wrap: wrap;
    }
    .item {
      display: flex;
      flex: 0 0 33.3%;
    }
    .title {
      padding-bottom: 10px;
      width: 70px;
      color: #738299;
    }
    .value {
      color: #b4c1d4;
    }
  }
  .operate-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90px;
    background: #4286f1;
    color: #fff;
    padding: 8px 12px;
    text-align: center;
    margin-left: 10px;
    border-radius: 25px;
    font-weight: 500;
  }
  .tag {
    margin-left: 4px;
    color: #fff;
    font-size: 13px;
    padding: 1px 2px;
    border-radius: 4px;
    border: 1px solid;
  }
}
.panelSwitch {
  width: 100px;
  height: 20px;
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  background-color: rgba(216, 216, 216, 0.4);
  cursor: pointer;
  text-align: center;
  &:hover {
    background-color: rgba(216, 216, 216, 0.6);
  }
}
</style>
